import { reportSPReducer } from "../reducer/ReportSPReducer";

export const reducer = reportSPReducer;
